<template>
  <div id="mySupersuPro" style="position:relative">
    <div class="head-btn head-btn2 t_r">
      <span @click="$router.go(-1)" class="btn-back">
        <span>返回</span>
      </span>
    </div>
    <div
      class="m_t_20 tableHeight"
      style="overflow: auto;max-height: calc(100vh - 200px);padding-bottom: 10px"
    >
      <div class="people-box">
        <nav>
          <span class="font18 f_w">人员组</span>
          <i @click="editMann()" class="icon iconfont iconbianji1 colorYellowF36A20 m_l_5"></i>
        </nav>
        <div>
          <div class="allDl p_t_b_15">
            <dl class="allDl_width30 allDl_span80">
              <dd>
                <span>人员组名称:</span>
                <div class="NoWrap" :title="mySuperInfo.name">{{ mySuperInfo.name }}</div>
              </dd>
              <dd style="width: 66%">
                <span>描述:</span>
                <div class="NoWrap" :title="mySuperInfo.describe">{{ mySuperInfo.describe }}</div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div>
        <nav class="uhTabDiv">
          <div>
            <ul>
              <li @click="seltuhTabNum(1)" :class="uhTabNum === 1 ? 'onUhTabLi': ''" class="c_p">
                <div>
                  <span>人员列表</span>
                </div>
              </li>
              <li @click="seltuhTabNum(2)" :class="uhTabNum === 2 ? 'onUhTabLi': ''" class="c_p">
                <div>
                  <span>权限设置</span>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="back_colorWidth p_b_10">
          <div v-if="uhTabNum === 1">
            <div class="allDl d_flex" style="padding: 20px 20px 10px 20px">
              <dl class="allDl_width50 allDl_span60" style="width: 80%">
                <dd style="margin: 0 10px 0 0">
                  <span>邮箱地址:</span>
                  <div>
                    <input v-model="mennData.Email" type="text" class="allInput" placeholder="请输入邮箱或关键字"/>
                  </div>
                </dd>
                <dt style="width: auto;;margin: 0 10px 0 0">
                  <button @click="getMannEmlSerch()" class="suerButton">
                    <i class="icon iconfont iconsousuo" style="font-size: 14px"></i>
                    <span class="m_l_5">搜索</span>
                  </button>
                </dt>
              </dl>
              <div>
                <button @click="editEml('', 2)" class="btn-green m_r_5 v_m" :disabled="pickMennEdit">
                  <span>编辑</span>
                </button>
                <button
                  @click="deltEml('', 2)"
                  class="suerButtonSolid btn-dele1 p_r m_r_5 v_m"
                  :disabled="pickMennEdit"
                >
                  <span>删除</span>
                </button>
                <button @click="addMannEm()" class="btn-white m_r_5 v_m">
                  <i class="icon iconfont iconaddApp"></i>
                  <span class="m_l_5">新建邮箱</span>
                </button>
                <section class="dis_line c_p v_m">
                  <input
                    @change="upEmlFile($event)"
                    type="file"
                    class="allBtFile"
                    id="emlFile"
                    accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  />
                  <label for="emlFile">
                    <img src="@/assets/icons/icon-export.png" width="16px" />
                    <span class="font12 m_l_5 c_p">导入邮箱</span>
                  </label>
                </section>
              </div>
            </div>
            <div style="padding: 0 20px">
              <table class="allTable" cellspacing="0">
                <thead>
                  <tr>
                    <th width="30">
                      <input
                        @change="titleCheckTwo()"
                        v-model="myMennData.isCheckFather"
                        type="checkbox"
                        class="allCheckbox"
                        id="pepoCheck_F"
                      />
                      <label for="pepoCheck_F"></label>
                    </th>
                    <th width="60">序号</th>
                    <th style="text-align: left">邮箱地址</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(item, index) in myMennData.myMennList">
                    <td>
                      <input
                        @change="listCheckedTwo()"
                        v-model="item.isCheckChild"
                        type="checkbox"
                        class="allCheckbox"
                        :id="'pepoCheck_S' + index"
                      />
                      <label :for="'pepoCheck_S' + index"></label>
                    </td>
                    <td>{{item.id}}</td>
                    <td class="t_l">{{ item.email }}</td>
                    <td class="colorYellowF36A20" width="60">
                      <div class="d_flex">
                        <span @click="editEml(item, 1)" class="c_p">编辑</span>
                        <span @click="deltEml(item, 1)" class="c_p colorDele">删除</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="myMennData.myMennList.length === 0">
                    <td colspan="4">暂无数据</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <page
              :totalCount="menntotalCount"
              v-if="menntotalPage !== 0"
              v-on:on-getList="getMannEmlList($event)"
              :totalPage="menntotalPage"
              :page="mennPage"
            ></page>
          </div>
          <div v-if="uhTabNum === 2" class="powerDiv">
            <div class="powerDiv_l">
              <p
                @click="leftPowMenuNum = index"
                :class="{'onPowerP': leftPowMenuNum === index, 'onPowerP_Color' : item.isShow}"
                :key="index"
                v-for="(item, index) in settMenu"
              >{{ item.name }}</p>
            </div>
            <div class="powerDiv_r" v-show="leftPowMenuNum === 0">
              <!-- <nav class="m_b_10">

              </nav> -->
              <div class="allDl d_flex m_b_5">
                <dl class="allDl_width50 allDl_span60" style="width: 80%">
                  <dd style="margin: 0 10px 0 0">
                    <span>文件名:</span>
                    <div>
                      <input v-model="powerData.FileName" type="text" class="allInput" />
                    </div>
                  </dd>
                  <dt style="width: auto;margin: 0 10px 0 0">
                    <button @click="getPowerSerch()" class="suerButton">
                      <i class="icon iconfont iconsousuo" style="font-size: 14px"></i>
                      <span class="m_l_5">搜索</span>
                    </button>
                  </dt>
                </dl>
                <div class="d_flex">
                    <div class="m_r_10">
                  <span>是否启用本权限</span>
                  <input
                    @change="seltPower()"
                    v-model="settMenu[leftPowMenuNum].isShow"
                    type="checkbox"
                    class="allSwitch"
                    :id="'checkSW' + leftPowMenuNum"
                  />
                  <label :for="'checkSW' + leftPowMenuNum" class="v_m"></label>
                </div>
                  <button @click="showModel2 = true" class="btn-white">
                    <i class="icon iconfont iconaddApp"></i>
                    <span>添加文件</span>
                  </button>
                </div>
              </div>
              <div>
                <table class="allTable" cellspacing="0">
                  <thead>
                    <tr>
                      <th>文件名</th>
                      <th>权限</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="index" v-for="(item, index) in myPowerList">
                      <td>{{item.fileName}}</td>
                      <td>
                        <input
                          @change="checkPower(item, 1)"
                          v-model="item.enableDownload"
                          type="checkbox"
                          class="allCheckbox"
                          :id="'trCheck' + index + item.id"
                        />
                        <label :for="'trCheck' + index + item.id"></label>
                        <label :for="'trCheck' + index + item.id" class="m_r_10">下载</label>
                        <input
                          @change="checkPower(item, 2)"
                          v-model="item.enableUpload"
                          type="checkbox"
                          class="allCheckbox"
                          :id="'trCheck1' + index + item.id"
                        />
                        <label :for="'trCheck1' + index + item.id"></label>
                        <label :for="'trCheck1' + index + item.id">上传</label>
                      </td>
                      <td class="colorYellowF36A20" width="30">
                        <span @click="deltPowerFile(item)" class="c_p colorDele">删除</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <page
                  :totalCount="powertotalCount"
                  v-if="powertotalPage !== 0"
                  v-on:on-getList="getPowerList($event)"
                  :totalPage="powertotalPage"
                  :page="powerPage"
                ></page>
              </div>
            </div>
            <div class="powerDiv_r" v-show="leftPowMenuNum === 1">
              <nav class="d_flex m_b_10">
                <div>
                  <span>是否启用本权限</span>
                  <input
                    @change="seltPower()"
                    v-model="settMenu[leftPowMenuNum].isShow"
                    type="checkbox"
                    class="allSwitch"
                    :id="'checkSW2' + leftPowMenuNum"
                  />
                  <label :for="'checkSW2' + leftPowMenuNum" class="v_m"></label>
                </div>
                <button style="visibility: hidden" class="suerButton">
                  <i class="icon iconfont iconaddApp"></i>
                  <span>添加文件</span>
                </button>
              </nav>
              <div>
                <table class="allTable" cellspacing="0">
                  <thead>
                    <tr>
                      <th colspan="2" style="text-align: left">权限</th>
                      <th>是否启用权限</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody :key="index" v-for="(item, index) in myDonldList">
                    <tr>
                      <td width="20" colspan="4" class="f_w" style="text-align: left">
                        <i
                          @click="onClickF(item)"
                          class="icon iconfont iconicon_7 dis_line"
                          :style="{'transform': item.isClickF ? '' : 'rotate(-90deg)'}"
                          style="transition: all .5s"
                        ></i>
                        <span class="m_l_10">{{ item.category }}</span>
                      </td>
                    </tr>
                    <tr :key="indexCl" v-for="(itemCl, indexCl) in item.list" v-if="item.isClickF">
                      <td width="20"></td>
                      <td style="text-align: left">{{ itemCl.wideTableName }}</td>
                      <td>
                        <input
                          @change="seltDown(itemCl)"
                          v-model="itemCl.isActive"
                          type="checkbox"
                          class="allSwitch"
                          :id="'checkSWCld1' + index + indexCl"
                        />
                        <label :for="'checkSWCld1' + index + indexCl" class="v_m"></label>
                      </td>
                      <td class="colorYellowF36A20" width="60">
                        <span @click="downSet(itemCl)" class="c_p">设置</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="powerDiv_r" v-show="leftPowMenuNum === 2">
              <nav class="d_flex m_b_10">
                <div>
                  <span>是否启用本权限</span>
                  <input
                    @change="seltPower()"
                    v-model="settMenu[leftPowMenuNum].isShow"
                    type="checkbox"
                    class="allSwitch"
                    :id="'checkSW2' + leftPowMenuNum"
                  />
                  <label :for="'checkSW2' + leftPowMenuNum" class="v_m"></label>
                </div>
                <button style="visibility: hidden" class="suerButton">
                  <i class="icon iconfont iconaddApp"></i>
                  <span>添加文件</span>
                </button>
              </nav>
              <div>
                <table class="allTable" cellspacing="0">
                  <thead>
                    <tr>
                      <th>权限</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="index" v-for="(item, index) in settMenu[leftPowMenuNum].child">
                      <td>{{ item.cName }}</td>
                      <td>
                        <input
                          @change="seltPower(item)"
                          v-model="item.isShow"
                          type="checkbox"
                          class="allSwitch"
                          :id="'checkSW2' + leftPowMenuNum + item.cId"
                        />
                        <label :for="'checkSW2' + leftPowMenuNum + item.cId" class="v_m"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <model
      v-if="showModel"
      :title="modeltitle"
      :minWidth="'50%'"
      :onButton="1"
      v-on:on-cancel="showModel = false"
      v-on:on-confirm="addConfirmEml()"
    >
      <div class="pd_10_20" style="max-height: 320px;overflow: auto">
        <ul class="staffUl">
          <li :key="index" v-for="(item, index) in modelEmlList" v-if="modelEmlList.length > 0">
            <div>
              <i class="icon iconfont iconyoujian colorGrayA7A7A7"></i>
              <input @blur="parityEml(item)" v-model="item.email" type="text" />
              <i
                v-if="parseInt(item.id) === 0"
                @click="deltMdEml(index)"
                class="icon iconfont iconguanbi colorYellowF36A20"
              ></i>
            </div>
          </li>
          <li style="width: auto" v-if="parseInt(isEditEml) === 1">
            <section @click="addMdEml()" class="adSection">
              <i class="icon iconfont iconaddApp"></i>
            </section>
          </li>
        </ul>
      </div>
    </model>
    <model
      v-if="showModel1"
      :title="'编辑人员组'"
      :minWidth="'400px'"
      :onButton="1"
      v-on:on-cancel="showModel1 = false"
      v-on:on-confirm="editSuper()"
    >
      <div class="pd_10_20">
        <div class="allDl m_t_20">
          <dl class="allDl_width100 allDl_span60">
            <dd>
              <span>人员组:</span>
              <div>
                <input v-model="newSuperInfo.name" type="text" class="allInput" placeholder="请输入" />
              </div>
            </dd>
            <dd>
              <span style="vertical-align: top">描述:</span>
              <div>
                <textarea
                  v-model="newSuperInfo.describe"
                  class="allTextarea"
                  rows="5"
                  style="vertical-align: top;width: calc(100% - 12px)"
                  placeholder="请输入"
                ></textarea>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </model>
    <model
      v-if="showModel2"
      :title="'选择文件'"
      :minWidth="'70%'"
      :onButton="0"
      v-on:on-cancel="showModel2 = false"
    >
      <div class="pd_10_20">
        <div class="allDl m_t_20">
          <dl class="allDl_width20 allDl_span60">
            <dd>
              <span>文件名:</span>
              <div>
                <input v-model="postData.FileName" type="text" class="allInput" />
              </div>
            </dd>
            <dd>
              <span>部门:</span>
              <div>
                <input v-model="postData.BU" type="text" class="allInput" />
              </div>
            </dd>
            <dd>
              <span>归属类别:</span>
              <div>
                <input v-model="postData.ProjectBelong" type="text" class="allInput" />
              </div>
            </dd>
            <dt style="width: auto">
              <button @click="getModelSerch()" class="suerButton">
                <i class="icon iconfont iconsousuo" style="font-size: 14px"></i>
                <span class="m_l_5">搜索</span>
              </button>
              <button @click="confrimSelect()" class="suerButton" :disabled="pickConfirm">
                <span class="m_l_5">确定</span>
              </button>
            </dt>
          </dl>
        </div>
        <div>
          <div style="max-height: 40vh;overflow: auto; ">
            <table class="allTable" cellspacing="0">
              <thead>
                <tr>
                  <th width="30">
                    <input
                      @change="checkAllFiles()"
                      v-model="isCheckAll"
                      type="checkbox"
                      class="allCheckbox"
                      id="pepoCheck_F"
                    />
                    <label for="pepoCheck_F"></label>
                  </th>
                  <th style="text-align: left">ID</th>
                  <th>文件名</th>
                  <th>部门</th>
                  <th>归属类别</th>
                  <th>上传方式</th>
                  <!-- <th>操作</th> -->
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in myMoleList">
                  <td>
                    <input
                      @change="checkFile(item)"
                      v-model="item.isChecked"
                      type="checkbox"
                      class="allCheckbox"
                      :id="'fileCheck' + index + item.id"
                    />
                    <label :for="'fileCheck' + index + item.id"></label>
                  </td>
                  <td style="text-align: left">{{ item.id }}</td>
                  <td>
                    <span
                      class="NoWrap dis_line"
                      style="max-width: 300px"
                      :title="item.fileName"
                    >{{ item.fileName }}</span>
                  </td>
                  <td>{{ item.bu }}</td>
                  <td>{{ item.projectBelong }}</td>
                  <td>{{ item.uploadMethod }}</td>
                  <!-- <td @click="seltRmvb(item)" class="colorYellowF36A20" width="30"><span class="c_p">选择</span></td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <page
            :totalCount="totalCount"
            v-if="totalPage !== 0"
            v-on:on-getList="getModelList($event)"
            :totalPage="totalPage"
            :page="page"
          ></page>
        </div>
      </div>
    </model>
    <model
      v-if="showModel3"
      :title="'设置'"
      :minWidth="'60%'"
      :onButton="1"
      v-on:on-cancel="showModel3 = false"
      v-on:on-confirm="confirmFractale()"
    >
      <div class="pd_10_20" style="min-height: 30vh;max-height: 50vh;overflow: auto">
        <div class="allDl">
          <dl class="allDl_width50 allDl_span80 allDl_span_tr">
            <dd
              style="margin-bottom: 20px"
              :key="index"
              v-for="(item, index) in myDownSet"
              v-if="myWorkType === 'Virtual'"
            >
              <span>{{ item.serchName }}</span>
              <div>
                <allSelect
                  v-on:on-change="seltVir($event, item)"
                  v-model="item.prictData"
                  :multiple="true"
                  :chooseData="item.serchList"
                  :needReturn="'id'"
                  :matchValue="'name'"
                  :showValue="'{{name}}'"
                  :width="'100%'"
                  :placeholder="'全部'"
                  :borderLine="'#E5E5E5'"
                ></allSelect>
              </div>
            </dd>
            <dd
              style="margin-bottom: 20px"
              :key="index"
              v-for="(item, index) in myDownSet"
              v-if="myWorkType === 'Default'"
            >
              <span>{{ item.serchName }}</span>
              <div>
                <allSelect
                  v-model="item.prictData"
                  :multiple="true"
                  :chooseData="item.serchList"
                  :needReturn="'id'"
                  :matchValue="'name'"
                  :showValue="'{{name}}'"
                  :width="'100%'"
                  :placeholder="'全部'"
                  :borderLine="'#E5E5E5'"
                ></allSelect>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import { console } from 'vuedraggable/src/util/helper'

export default {
  name: 'mySupersuPro',
  data () {
    return {
      cslist: [
        {
          id: '',
          name: '全部'
        },
        {
          id: 1,
          name: '111'
        },
        {
          id: 2,
          name: '222'
        },
        {
          id: 3,
          name: '333'
        }
      ],
      csData: '',
      formId: parseInt(this.$route.query.formId),
      menntotalPage: 0,
      menntotalCount: 0,
      mennPage: 1,
      mennData: {
        GroupId: 0,
        Email: '',
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      mennSerchData: {
        GroupId: 0,
        Email: '',
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      powertotalPage: 0,
      powertotalCount: 0,
      powerPage: 1,
      powerData: {
        GroupId: 0,
        FileName: '',
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      powerSerchData: {
        GroupId: 0,
        FileName: '',
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        FileName: '',
        BU: '',
        ProjectBelong: '',
        UploadFrequency: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      serchData: {
        FileName: '',
        BU: '',
        ProjectBelong: '',
        UploadFrequency: 0,
        GroupId: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      showModel: false,
      modeltitle: '',
      showModel1: false,
      showModel2: false,
      showModel3: false,
      uhTabNum: 1,
      leftPowMenuNum: 0,
      myMennData: {
        isCheckFather: false,
        myMennList: []
      },
      myPowerList: [],
      myMoleList: [],
      moleSelectIds: [],
      mySuperInfo: {
        id: 0,
        name: '',
        describe: ''
      },
      newSuperInfo: {
        id: 0,
        name: '',
        describe: ''
      },
      modelEmlList: [],
      modelEmlData: {
        id: 0,
        email: ''
      },
      addModelEml: [],
      isEditEml: 1,
      settMenu: [],
      myDonldList: [],
      myDownSet: [],
      myWorkType: '',
      allKey2: [],
      allKeyName: [],
      mydownTableId: 0,
      channelData: {
        id: 1,
        prictData: '',
        serchName: '',
        serchList: [
          {
            id: '',
            name: '全部'
          }
        ]
      },
      storeData: {
        id: 2,
        prictData: '',
        serchName: '',
        serchList: [
          {
            id: '',
            name: '全部'
          }
        ]
      },
      edList: [],
      isCheckAll: false,
      unTableId: 0
    }
  },
  created () {
    if (this.formId > 0) {
      this.getAllDetail()
      this.getMannEmlList(1)
      this.getAllMenu()
      this.getPowerList(1)
      this.getWideTableList()
    }
    this.moleSelectIds = []
    this.getModelList(1)
  },
  computed: {
    // 编辑
    pickMennEdit () {
      let flag = false
      for (let i = 0; i < this.myMennData.myMennList.length; i++) {
        if (this.myMennData.myMennList[i].isCheckChild) {
          flag = true
        }
      }
      return !flag
    },
    pickConfirm () {
      /* let flag = false
       for (let i = 0; i < this.myMoleList.length; i++) {
        if (this.myMoleList[i].isChecked) {
          flag = true
        }
      }
      return !flag */
      return this.moleSelectIds.length === 0
    }
  },
  methods: {
    getAllDetail () {
      this.$axiox.get('/api/Role/RoleDetail?groupid=' + this.formId).then(msg => {
        this.mySuperInfo = msg.data
      })
    },
    editMann () {
      this.newSuperInfo = JSON.parse(JSON.stringify(this.mySuperInfo))
      this.showModel1 = true
    },
    editSuper () {
      if (this.newSuperInfo.name === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入人员组',
          stayTime: 5
        })
        return
      }
      this.$axiox.post('/api/Role/AddRole', this.newSuperInfo).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '修改成功',
          stayTime: 5
        })
        this.showModel1 = false
        this.getAllDetail()
      })
    },
    // 获取人员列表
    getMannEmlSerch () {
      this.mennSerchData = JSON.parse(JSON.stringify(this.mennData))
      this.getMannEmlList(1)
    },
    getMannEmlList (page) {
      this.mennSerchData.GroupId = this.formId
      let data = JSON.parse(JSON.stringify(this.mennSerchData))
      data.PageIndex = page
      let url = this.$commonJs.returnQuery('/api/Role/QueryUser', data)
      this.$axiox.get(url).then(msg => {
        this.myMennData.myMennList = msg.datas || []
        this.mennPage = page
        this.menntotalPage = Math.ceil(msg.total / this.mennSerchData.PageSize)
        this.menntotalCount = msg.total
        for (let i = 0; i < this.myMennData.myMennList.length; i++) {
          this.$set(this.myMennData.myMennList[i], 'isCheckChild', false)
        }
        this.myMennData.isCheckFather = false
      })
    },
    addMannEm () {
      this.modelEmlList = []
      this.isEditEml = 1
      this.showModel = true
      this.modeltitle = '新建邮箱'
    },
    editEml (item, type) {
      this.modelEmlList = []
      if (parseInt(type) === 1) {
        this.modelEmlList.push(JSON.parse(JSON.stringify(item)))
      } else {
        for (let i = 0; i < this.myMennData.myMennList.length; i++) {
          if (this.myMennData.myMennList[i].isCheckChild) {
            this.modelEmlList.push(JSON.parse(JSON.stringify(this.myMennData.myMennList[i])))
          }
        }
      }
      this.isEditEml = 2
      this.showModel = true
      this.modeltitle = '编辑邮箱'
    },
    async upEmlFile (e) {
      let file = e.target.files[0]
      if (this.$commonJs.excelUpLoadFile.indexOf(file.name.toLowerCase().split('.')[file.name.toLowerCase().split('.').length - 1]) < 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请上传excel文件',
          stayTime: 5
        })
        return
      }
      e.target.value = ''
      let fileId = await this.$commonJs.upSupportFile(file, '/api/Role/UploadEmail?groupid=' + this.formId, 'file')
      if (fileId.isSuccess) {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '上传成功',
          stayTime: 5
        })
        this.getMannEmlList(this.mennPage)
      }
      e.target.value = ''
    },
    addMdEml () {
      this.modelEmlList.push(JSON.parse(JSON.stringify(this.modelEmlData)))
    },
    deltMdEml (index) {
      this.modelEmlList.splice(index, 1)
    },
    parityEml (item) {
      if (item.email !== '') {
        if (this.$commonJs.returnDigit(item.email, 'email', '邮箱不正确')) {
          item.email = ''
        }
        if (parseInt(this.isEditEml) === 1) {
          let flag = false
          for (let i = 0; i < this.myMennData.myMennList.length; i++) {
            if (item.email === this.myMennData.myMennList[i].email) {
              flag = true
            }
          }
          if (flag) {
            this.$commonJs.alertTips({
              type: 'eror',
              title: '错误',
              content: '邮箱重复',
              stayTime: 5
            })
            item.email = ''
          }
        }
      }
    },
    addConfirmEml () {
      let flag1 = false
      let flag2 = false
      for (let i = 0; i < this.modelEmlList.length; i++) {
        if (this.modelEmlList[i].email === '') {
          flag2 = true
        }
      }
      if (flag2) {
        this.$commonJs.alertTips({
          type: 'eror',
          title: '错误',
          content: '请输入邮箱',
          stayTime: 5
        })
        return
      }
      for (let i = 0; i < this.modelEmlList.length; i++) {
        for (let j = i + 1; j < this.modelEmlList.length; j++) {
          if (this.modelEmlList[i].email === this.modelEmlList[j].email) {
            flag1 = true
          }
        }
      }
      if (flag1) {
        this.$commonJs.alertTips({
          type: 'eror',
          title: '错误',
          content: '邮箱重复',
          stayTime: 5
        })
        return
      }
      this.addModelEml = []
      for (let i = 0; i < this.modelEmlList.length; i++) {
        if (parseInt(this.modelEmlList[i].id) === 0 && this.modelEmlList[i].email !== '') {
          this.addModelEml.push(this.modelEmlList[i].email)
        }
        if (parseInt(this.modelEmlList[i].id) !== 0) {
          let data = {
            id: this.modelEmlList[i].id,
            email: this.modelEmlList[i].email
          }
          this.addModelEml.push(data)
        }
      }
      let url = ''
      let title = ''
      if (this.isEditEml === 1) {
        url = '/api/Role/AddUser?groupid=' + this.formId
        title = '新建成功'
      } else if (this.isEditEml === 2) {
        let flag = false
        for (let i = 0; i < this.addModelEml.length; i++) {
          if (this.addModelEml[i].email === '') {
            flag = true
          }
        }
        if (flag) {
          this.$commonJs.alertTips({
            type: 'eror',
            title: '错误',
            content: '请输入邮箱',
            stayTime: 5
          })
          return
        }
        url = '/api/Role/UpdateUser?groupid=' + this.formId
        title = '编辑成功'
      }
      this.$axiox.post(url, this.addModelEml).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: title,
          stayTime: 5
        })
        this.showModel = false
        this.getMannEmlList(this.mennPage)
      })
    },
    deltEml (item, type) {
      this.$commonJs.doubleComfirm({
        content: '是否删除所选人员？',
        successFun: msg => {
          let data = []
          if (parseInt(type) === 1) {
            data.push(parseInt(item.id))
          } else if (parseInt(type) === 2) {
            for (let i = 0; i < this.myMennData.myMennList.length; i++) {
              if (this.myMennData.myMennList[i].isCheckChild) {
                data.push(parseInt(this.myMennData.myMennList[i].id))
              }
            }
          }
          this.$axiox.post('/api/Role/DeleteUser', data).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getMannEmlList(this.mennPage)
          })
        },
        errorFun: msg => {
        }
      })
    },
    seltuhTabNum (num) {
      this.uhTabNum = parseInt(num)
      this.leftPowMenuNum = 0
      if (num === 1) {
        for (let i = 0; i < this.myMennData.myMennList.length; i++) {
          this.$set(this.myMennData.myMennList[i], 'isCheckChild', false)
        }
        this.myMennData.isCheckFather = false
      } else {
        this.moleSelectIds = []
        for (let i = 0; i < this.myMoleList.length; i++) {
          this.$set(this.myMoleList[i], 'isChecked', false)
        }
        this.isCheckAll = false
      }
    },
    // 获取菜单
    getAllMenu () {
      this.$axiox.get('/api/Role/GetAllMenu?groupid=' + this.formId).then(msg => {
        this.settMenu = msg.data || []
        let list = []
        for (let i = 0; i < this.settMenu.length; i++) {
          if (this.settMenu[i].code === 'Download') {
            list = JSON.parse(JSON.stringify(this.settMenu[i].child))
          }
          if (this.settMenu[i].code === 'SystemMange') {
            this.settMenu[i].child = this.settMenu[i].child.concat(list)
          }
        }
      })
    },
    getModelSerch () {
      this.serchData = JSON.parse(JSON.stringify(this.postData))
      this.moleSelectIds = []
      this.getModelList(1)
    },
    getModelList (page) {
      this.serchData.GroupId = this.formId
      let data = JSON.parse(JSON.stringify(this.serchData))
      data.PageIndex = page
      // let url = this.$commonJs.returnQuery('/api/FileSet/list', data)
      let url = this.$commonJs.returnQuery('/api/Role/list', data)
      this.$axiox.get(url).then(msg => {
        this.myMoleList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.serchData.PageSize)
        this.totalCount = msg.total
        for (let i = 0; i < this.myMoleList.length; i++) {
          this.$set(this.myMoleList[i], 'isChecked', this.isExistMoleSelect(this.myMoleList[i].id))
        }
        if (this.myMoleList.some((i) => i.isChecked === false)) { this.isCheckAll = false } else { this.isCheckAll = true }
      })
    },
    // 判断是否已选择
    isExistMoleSelect (id) {
      var arrIndex = this.moleSelectIds.indexOf(id)
      if (arrIndex >= 0) { return true } else { return false }
    },
    seltPower (item) {
      let data = {
        groupid: 0,
        menuid: 0,
        isenable: false
      }
      if (item) {
        data = {
          groupid: this.formId,
          menuid: item.cId,
          isenable: item.isShow
        }
      } else {
        data = {
          groupid: this.formId,
          menuid: this.settMenu[this.leftPowMenuNum].id,
          isenable: this.settMenu[this.leftPowMenuNum].isShow
        }
      }
      let url = this.$commonJs.returnQuery('/api/Role/EnableMenu', data)
      this.$axiox.get(url).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '操作成功',
          stayTime: 5
        })
        this.getAllMenu()
      })
    },
    // 获取数据文件列表
    getPowerSerch () {
      this.powerSerchData = JSON.parse(JSON.stringify(this.powerData))
      this.getPowerList(1)
    },
    getPowerList (page) {
      this.powerSerchData.GroupId = this.formId
      let data = JSON.parse(JSON.stringify(this.powerSerchData))
      data.PageIndex = page
      let url = this.$commonJs.returnQuery('/api/Role/GetItemInfo', data)
      this.$axiox.get(url).then(msg => {
        this.myPowerList = msg.datas || []
        this.powerPage = page
        this.powertotalPage = Math.ceil(msg.total / this.powerSerchData.PageSize)
        this.powertotalCount = msg.total
      })
    },
    seltRmvb (item) {
      this.$axiox.get('/api/Role/AddItemInfo?groupid=' + this.formId + '&id=' + item.id).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '添加成功',
          stayTime: 5
        })
        this.showModel2 = false
        this.getPowerList(this.powerPage)
      })
    },
    checkPower (item, type) {
      let data = {
        id: item.id,
        type: type,
        isenable: parseInt(type) === 1 ? item.enableDownload : item.enableUpload
      }
      let url = this.$commonJs.returnQuery('/api/Role/UpdateItemInfo', data)
      this.$axiox.get(url).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '操作成功',
          stayTime: 5
        })
        this.getPowerList(this.powerPage)
      })
    },
    deltPowerFile (item) {
      this.$commonJs.doubleComfirm({
        content: '是否删除此文件？',
        successFun: msg => {
          this.$axiox.get('/api/Role/DeleteItemInfo?id=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getPowerList(this.powerPage)
          })
        },
        errorFun: msg => {
        }
      })
    },
    // 获取数据下载列表
    getWideTableList () {
      this.$axiox.get('/api/Role/GetWideTableList?groupid=' + this.formId).then(msg => {
        console.log(msg)
        this.myDonldList = msg.data || []
        for (let i = 0; i < this.myDonldList.length; i++) {
          this.$set(this.myDonldList[i], 'isClickF', true)
        }
      })
    },
    // 获取已设置
    getColumnValue (item, callBack) {
      this.$axiox.post(`/api/Role/GetColumnValue?groupid=${this.formId}&tableid=${item.id}`).then(msg => {
        // if (msg.data) {
        //   for (let i = 0; i < msg.data.length; i++) {
        //     if (msg.data[i].key === 'key1') {
        //       this.channelData.prictData = msg.data[i].value
        //     }
        //   }
        //   console.log(this.channelData.prictData)
        // }
        // console.log(msg)
        if (callBack) {
          callBack(msg)
        }
      })
    },
    seltDown (item) {
      this.$axiox.get(`/api/Role/EnableWideTable?groupid=${this.formId}&wideid=${item.id}&isenable=${item.isActive}`).then(msg => {
        this.getWideTableList()
      })
    },
    downSet (item) {
      console.log(item)
      this.showModel3 = true
      this.myWorkType = item.wideTableType
      this.mydownTableId = item.id
      this.unTableId = item.childTableId
      this.myDownSet = []

      let url = ''
      if (item.wideTableType === 'Virtual') {
        url = `/api/Role/GetKeyValueMap?groupid=${this.formId}&wideid=${item.id}`
      } else if (item.wideTableType === 'Default') {
        url = `/api/Role/GetWideTableSetColumn?groupid=${this.formId}&wideid=${item.id}`
      }
      this.getColumnValue(item, p => {
        this.$axiox.get(url).then(msg => {
          console.log(msg)
          let data1 = {
            id: 1,
            prictData: '',
            serchName: '',
            serchList: [
              {
                id: '',
                name: '全部'
              }
            ]
          }
          let data2 = {
            id: 2,
            prictData: '',
            serchName: '',
            serchList: [
              {
                id: '',
                name: '全部'
              }
            ]
          }
          if (item.wideTableType === 'Virtual') {
            this.edList = []
            if (p.data) {
              let list = []
              for (let i = 0; i < p.data.length; i++) {
                if (p.data[i].key === 'key1') {
                  list.push(p.data[i].value)
                  this.edList.push(p.data[i].value)
                  data1.prictData = list.join(',')
                }
                if (p.data[i].key === 'key2') {
                  list.push(p.data[i].value)
                  data2.prictData = list.join(',')
                }
              }
            }
            let chanlList = msg.data
            data1.serchName = chanlList.key1DisplayName
            for (let i = 0; i < chanlList.key1.length; i++) {
              let data = {
                id: chanlList.key1[i].key1Name,
                name: chanlList.key1[i].key1Name,
                columnName: chanlList.key1[i].key2ColumnName
              }
              data1.serchList.push(data)
            }
            for (let i = 0; i < data1.serchList.length; i++) {
              this.$set(data1.serchList[i], 'clidList', [])
              for (let j = 0; j < chanlList.key2.length; j++) {
                if (data1.serchList[i].name === chanlList.key2[j].key1Name) {
                  this.$set(data1.serchList[i], 'clidList', chanlList.key2[j].key2Name)
                }
              }
            }
            this.myDownSet.push(data1)
            data2.serchName = chanlList.key2DisplayName
            data2.serchList = [
              {
                id: '',
                name: '全部'
              }
            ]
            for (let i = 0; i < chanlList.key2.length; i++) {
              let list = []
              if (this.edList.length > 0) {
                for (let j = 0; j < chanlList.key2[i].key2Name.length; j++) {
                  if (this.edList.indexOf(chanlList.key2[i].key1Name) >= 0) {
                    let data = {
                      id: chanlList.key2[i].key2Name[j],
                      name: chanlList.key2[i].key2Name[j]
                    }
                    list.push(data)
                  }
                }
              } else {
                for (let j = 0; j < chanlList.key2[i].key2Name.length; j++) {
                  let data = {
                    id: chanlList.key2[i].key2Name[j],
                    name: chanlList.key2[i].key2Name[j]
                  }
                  list.push(data)
                }
              }
              data2.serchList = data2.serchList.concat(list)
              data2.serchList = this.$commonJs.returnHeavy(data2.serchList, 'name')
            }
            this.myDownSet.push(data2)
          } else if (item.wideTableType === 'Default') {
            let newList = msg.data || []
            for (let i = 0; i < newList.length; i++) {
              let data = {
                id: newList[i].id,
                key: newList[i].dataDicKey,
                serchName: newList[i].displayColumnName,
                dataDicTableName: newList[i].dataDicTableName,
                prictData: '',
                serchList: [
                  {
                    id: '',
                    name: '全部'
                  }
                ]
              }
              this.myDownSet.push(data)
            }
            let newData = []
            if (p.data) {
              let data = []
              for (let i = 0; i < p.data.length; i++) {
                data.push(p.data[i].key)
              }
              data = this.$commonJs.returnHeavy(data)
              for (let i = 0; i < data.length; i++) {
                let object = {
                  key: data[i],
                  valus: []
                }
                newData.push(object)
              }
              for (let i = 0; i < p.data.length; i++) {
                for (let j = 0; j < newData.length; j++) {
                  if (newData[j].key === p.data[i].key) {
                    newData[j].valus.push(p.data[i].value)
                  }
                }
              }
            }
            for (let i = 0; i < this.myDownSet.length; i++) {
              for (let j = 0; j < newData.length; j++) {
                if (newData[j].key === this.myDownSet[i].key) {
                  this.myDownSet[i].prictData = newData[j].valus.join(',')
                }
              }
              this.getValueList(this.myDownSet[i])
            }
            // console.log(this.myDownSet)
          }
        })
      })
    },
    seltVir (e, item) {
      if (parseInt(item.id) === 1) {
        let list = []
        for (let i = 0; i < item.serchList.length; i++) {
          if (item.prictData === '') {
            list = list.concat(item.serchList[i].clidList)
            list = this.$commonJs.returnHeavy(list)
          }
          if (item.prictData.indexOf(item.serchList[i].id) >= 0) {
            list = list.concat(item.serchList[i].clidList)
            list = this.$commonJs.returnHeavy(list)
          }
        }
        for (let i = 0; i < this.myDownSet.length; i++) {
          if (parseInt(this.myDownSet[i].id) !== parseInt(item.id)) {
            this.myDownSet[i].prictData = ''
            this.myDownSet[i].serchList = [
              {
                id: '',
                name: '全部'
              }
            ]
            for (let j = 0; j < list.length; j++) {
              let data = {
                id: list[j],
                name: list[j]
              }
              this.myDownSet[i].serchList.push(data)
            }
          }
        }
      } else {
        console.log(item)
      }
    },
    getValueList (item) {
      console.log(item)
      if (item.serchList.length <= 1) {
        let data = {
          DbName: item.dataDicTableName,
          Dickey: item.key || '',
          Keyword: '',
          TableId: this.unTableId,
          PageIndex: 1,
          PageSize: 100
        }
        let url = this.$commonJs.returnQuery('/api/Download/GetVauleByDicKey', data)
        item.serchList = [
          {
            id: '',
            name: '全部'
          }
        ]
        this.$axiox.get(url).then(msg => {
          let list = msg.data.values || []
          for (let i = 0; i < list.length; i++) {
            let object = {
              id: list[i],
              name: list[i]
            }
            item.serchList.push(object)
          }
        })
      }
    },
    confirmFractale () {
      let list = []
      if (this.myWorkType === 'Virtual') {
        for (let i = 0; i < this.myDownSet.length; i++) {
          if (parseInt(this.myDownSet[i].id) === 1) {
            if (this.myDownSet[i].prictData === '') {
              let data = {
                key: 'key1',
                value: '*gskallvalue*'
              }
              list.push(data)
            }
            if (this.myDownSet[i].prictData !== '') {
              let newPrict = this.myDownSet[i].prictData.split(',')
              for (let j = 0; j < newPrict.length; j++) {
                let data = {
                  key: 'key1',
                  value: newPrict[j]
                }
                list.push(data)
              }
            }
          }
          if (parseInt(this.myDownSet[i].id) === 2) {
            if (this.myDownSet[i].prictData === '') {
              let data = {
                key: 'key2',
                value: '*gskallvalue*'
              }
              list.push(data)
            }
            if (this.myDownSet[i].prictData !== '') {
              let newPrict = this.myDownSet[i].prictData.split(',')
              for (let j = 0; j < newPrict.length; j++) {
                let data = {
                  key: 'key2',
                  value: newPrict[j]
                }
                list.push(data)
              }
            }
          }
        }
      } else {
        let valueList = []
        for (let i = 0; i < this.myDownSet.length; i++) {
          if (this.myDownSet[i].prictData === '') {
            let data = {
              key: this.myDownSet[i].key,
              value: '*gskallvalue*'
            }
            list.push(data)
          }
          if (this.myDownSet[i].prictData) {
            valueList = valueList.concat(this.myDownSet[i].prictData.split(','))
          }
        }
        for (let i = 0; i < this.myDownSet.length; i++) {
          for (let j = 0; j < valueList.length; j++) {
            if (this.myDownSet[i].prictData.indexOf(valueList[j]) >= 0) {
              let data = {
                key: this.myDownSet[i].key,
                value: valueList[j]
              }
              list.push(data)
            }
          }
        }
      }
      // return
      this.$axiox.post('/api/Role/AddColumnValue?groupid=' + this.formId + '&tableid=' + this.mydownTableId, list).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '设置成功',
          stayTime: 5
        })
        this.showModel3 = false
        this.getWideTableList()
      })
    },
    // 表格全选和单选
    titleCheckTwo () {
      for (let i = 0; i < this.myMennData.myMennList.length; i++) {
        this.$set(this.myMennData.myMennList[i], 'isCheckChild', this.myMennData.isCheckFather)
      }
    },
    listCheckedTwo () {
      let flag = true
      for (let i = 0; i < this.myMennData.myMennList.length; i++) {
        if (!this.myMennData.myMennList[i].isCheckChild) {
          flag = false
        }
      }
      if (flag) {
        this.myMennData.isCheckFather = true
      } else {
        this.myMennData.isCheckFather = false
      }
    },
    // 文件全选
    checkAllFiles () {
      for (let i = 0; i < this.myMoleList.length; i++) {
        this.$set(this.myMoleList[i], 'isChecked', this.isCheckAll)
        this.saveSelectId(this.myMoleList[i])
      }
    },
    // 单选
    checkFile (item) {
      this.saveSelectId(item)

      let flag = true
      for (let i = 0; i < this.myMoleList.length; i++) {
        if (!this.myMoleList[i].isChecked) {
          flag = false
        }
      }
      if (flag) {
        this.isCheckAll = true
      } else {
        this.isCheckAll = false
      }
    },
    saveSelectId (item) {
      // 存储已选项，分页
      var arrIndex = this.moleSelectIds.indexOf(item.id)
      console.log(item, arrIndex, this.moleSelectIds)
      if (item.isChecked) {
        if (arrIndex === -1) {
          this.moleSelectIds.push(item.id)
        }
      } else {
        if (arrIndex >= 0) {
          this.moleSelectIds.splice(arrIndex, 1)
        }
      }
    },
    confrimSelect () {
      let ids = []
      for (let i = 0; i < this.myMoleList.length; i++) {
        if (this.myMoleList[i].isChecked) {
          ids.push(this.myMoleList[i].id)
        }
      }
      this.$axiox.post('/api/Role/AddItemInfo?groupid=' + this.formId, this.moleSelectIds).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '添加成功',
          stayTime: 5
        })
        this.showModel2 = false
        this.moleSelectIds = []
        this.getPowerList(this.powerPage)
        this.getModelList(1)
      })
    }
  }
}
</script>

<style scoped>
.people-box{
  background: #fff;
  box-shadow: 0px 2px 30px 0px rgba(41,84,160,0.1);
  border-radius: 15px;
  margin:10px 20px 20px 20px;
  padding:20px 20px 0 20px;
}
.powerDiv_l{
  background: rgba(243,244,249,0.6);
  border-radius: 10px 10px 10px 10px;
  min-height:400px;
  padding:20px 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/mySupersuPro.vue